module.exports = __webpack_public_path__ + "img/loading.5b81174c.gif";